<template>
  <div class="audio-player">
    <!-- :src="require(`${list[index].url}`) closeIcon -->
    <div class="title" v-if="data.title">
      {{data.title||''}}
    </div>
    <div v-if="data.createTime">
      {{data.createTime}}
    </div>

    <div v-if="data.description">
      {{data.description||''}}
    </div>
    <audio ref="audio-player" preload="auto" @ended="endedHandle">
    </audio>
    <div>
      <a-row style="text-align: center">
        <!--在drawer里面使用滑动条 会控制台报错，但是实际不影响页面使用。-->
        <a-col :span="data.id?18:24">
          <a-slider  :marks="marks" v-model="currentTime" :min="0" :step="0.01" :max="totalTime"  :tooltipVisible="false" @change="currentTimeChange"/>
        </a-col>
        <a-col :span="data.id?6:0">
          <a-button icon="delete" style="margin-top: 10px" type="danger" @click="deleteHandle"></a-button>
        </a-col>
      </a-row>
      <span>
        <a-icon type="caret-right"  v-if="!playing" class="icon-btn" @click="playHandle"/>
        <a-icon type="pause" v-else class="icon-btn" @click="stopHandle"/>
      </span>


      <a-radio-group style="margin-left: 40px" v-model="playbackRate" @change="playbackRateChange" size="small">
        <a-radio-button :value="1">
          1 X
        </a-radio-button>
        <a-radio-button :value="1.25">
          1.25 X
        </a-radio-button>
        <a-radio-button :value="1.5">
          1.5 X
        </a-radio-button>
        <a-radio-button :value="2">
          2 X
        </a-radio-button>
      </a-radio-group>
      <span style="margin-left: 40px">
        <a-icon :component="soundCloseSvg"  v-if="currentVolume ===0" class="icon-btn" @click="volumeHandle(1)" />
        <a-icon :component="soundOpenSvg" v-else class="icon-btn" @click="volumeHandle(0)"/>
      </span>
    </div>
  </div>
</template>

<script>
  import { downFile, downFileByLocalPath,deleteAction } from '@/api/manage'

  export default {
    name: 'Play',
    props: {
      // 播放列表
      data: {
        default: function () {
          return {};
        },
      },
      localPath:{
        type:Boolean,
        default :false
      }
      //  播放索引
      // index
    },
    data() {
      return {
        box: undefined,
        fileBaseUrl:window._CONFIG['staticDomainURL'],
        // fileBaseUrl:'/sys/common/static',
        totalTimeStr:'00:00',
        currentTimeStr:'00:00',
        soundCloseSvg : {
          render(h) {
            return (
              <svg t="1668050596809" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                   p-id="4723" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
                <path
                  d="M553.948279 55.153116a48.580465 48.580465 0 0 0-30.684279 11.121117L258.714791 294.816744H73.013581c-40.20986 0-72.489674 32.279814-72.489674 71.953861L0 679.995535c0 39.685953 32.803721 72.477767 73.013581 72.477767H261.35814l260.834232 205.288186a46.734884 46.734884 0 0 0 30.684279 11.097303c25.373767 0 48.663814-19.57507 48.663814-48.128l1.047814-817.413954c0.559628-28.600558-23.242419-48.163721-48.64-48.163721z m-24.349767 816.354233L305.806884 695.331721a71.930047 71.930047 0 0 0-44.436837-15.336186H71.95386l1.059721-312.689116 185.70121-0.512c17.467535 0 33.863442-6.370233 47.092093-17.467535l224.851349-194.16707-1.059721 716.347535z m0 0"
                  p-id="4724"></path>
                <path
                  d="M1012.950326 624.568558c14.57414 14.57414 14.764651 38.018977 0.416744 52.366884-14.347907 14.347907-37.792744 14.169302-52.366884-0.404837L683.901023 399.431442c-14.57414-14.57414-14.764651-38.018977-0.416744-52.366884 14.347907-14.347907 37.792744-14.157395 52.366884 0.416744l277.099163 277.087256z m0 0"
                  p-id="4725"></path>
                <path
                  d="M960.988279 347.481302c14.57414-14.57414 38.018977-14.764651 52.366884-0.416744 14.347907 14.347907 14.157395 37.792744-0.416744 52.366884L735.851163 676.518698c-14.57414 14.57414-38.018977 14.764651-52.366884 0.404837-14.347907-14.347907-14.169302-37.792744 0.404837-52.366884l277.099163-277.075349z m0 0"
                  p-id="4726"></path>
              </svg>)  // jsx
          }
        },
        soundOpenSvg : {
          render(h){
            return (
              <svg t="1668050571898" className="icon" viewBox="0 0 1024 1024" version="1.1"
                   xmlns="http://www.w3.org/2000/svg" p-id="3602" xmlns:xlink="http://www.w3.org/1999/xlink" width="200"
                   height="200">
                <path
                  d="M128 420.576v200.864h149.12l175.456 140.064V284.288l-169.792 136.288H128z m132.256-64l204.288-163.968a32 32 0 0 1 52.032 24.96v610.432a32 32 0 0 1-51.968 24.992l-209.92-167.552H96a32 32 0 0 1-32-32v-264.864a32 32 0 0 1 32-32h164.256zM670.784 720.128a32 32 0 0 1-44.832-45.664 214.08 214.08 0 0 0 64.32-153.312 213.92 213.92 0 0 0-55.776-144.448 32 32 0 1 1 47.36-43.04 277.92 277.92 0 0 1 72.416 187.488 278.08 278.08 0 0 1-83.488 198.976zM822.912 858.88a32 32 0 1 1-45.888-44.608A419.008 419.008 0 0 0 896 521.152c0-108.704-41.376-210.848-114.432-288.384a32 32 0 0 1 46.592-43.872c84.16 89.28 131.84 207.04 131.84 332.256 0 127.84-49.76 247.904-137.088 337.728z"
                  p-id="3603"></path>
              </svg>
            )
          }
        },
        playbackRate:1,// 倍速
        totalTime:0,//总时长
        currentTime:0,// 播放时长
        playing:false,
        currentVolume:1,//音量
      }
    },
    mounted() {
      this.init();
    },
    computed:{
      marks(){
        const totalTime = this.totalTime
        const marks = {
          0:this.currentTimeStr
        }
        marks[totalTime] = this.totalTimeStr
        return marks
      }
    },
    watch:{
      data(){
        this.init()
      }
    },
    methods: {
      init() {
        if(!this.data.path){
          return
        }
        this.box = this.$refs["audio-player"];
        const resFn = (data) => {
          if (!data || data.size === 0) {
            Vue.prototype['$message'].warning('文件下载失败')
            return
          }
          // const file  = new File(), 'my.mp3')
          //必须先下载下来，直接用url不得行
          this.box.src = URL.createObjectURL(new Blob([data]));
          // this.box.src = require(`@/assets/1585447716231389185_1667982069676_1667982074491.wav`);
          const that = this;

          //  this.duration  =  this.formatTime(this.box.duration)
          // 绑定三个触发方法
          // 当时长有变化时触发，由"NaN"变为实际时长也算
          this.box.ondurationchange = function () {
            console.log("时长发生了变化:"+ that.box.duration );
          };
          // 当前数据可用是触发
          this.box.oncanplay = function () {
            // console.log("已经可以播放了");
            const totalTime = that.box.duration
            that.totalTime = parseInt(totalTime)
            that.totalTimeStr = that.formatSeconds(totalTime)
          };
          // 播放位置发送改变时触发。
          this.box.ontimeupdate = function () {
            // console.log("播放位置发送了变动:",that.box.currentTime);
            const currentTime = that.box.currentTime
            that.currentTime = currentTime
            that.currentTimeStr = that.formatSeconds(currentTime)
          };
          // 音频播放完毕
          this.box.onended = function () {
            console.log("播放完毕，谢谢收听");
          };
          // 音频播放完毕
          this.box.onerror = function () {
            console.log("加载出错！");
          };
        }
        if(this.localPath){
          downFileByLocalPath(this.data.path).then(resFn)
        }else{
          downFile(`${this.fileBaseUrl}/${this.data.path}`).then(resFn)
        }

      },
      volumeHandle(value){
        this.currentVolume = value
        this.box.volume = this.currentVolume
      },
      playHandle(){
        this.playing = true
        this.box.play()
      },
      endedHandle(){
        this.playing = false
        // this.box.play() //要调用一下再播放，不知道为什么
      },
      stopHandle(){
        this.playing = false
        this.box.pause()
      },
      playbackRateChange(){
        if(this.box){
          this.box.playbackRate = this.playbackRate
        }else{
          this.$message.warning('播放器未初始化完成')
          this.playbackRate = 1
        }
      },
      currentTimeChange(value){
        if(this.box){
          this.box.currentTime = parseInt(this.currentTime)
        }else{
          this.$message.warning('播放器未初始化完成')
        }
      },
      formatSeconds(value) {
        //  秒
        let second = parseInt(value)
        //  分
        let minute = 0
        //  如果秒数大于60，将秒数转换成整数
        if (second > 60) {
          //  获取分钟，除以60取整数，得到整数分钟
          minute = parseInt(second / 60)
          //  获取秒数，秒数取佘，得到整数秒数
          second = parseInt(second % 60)
        }
        let result = `${minute<10?'0'+minute:minute}:${second<10?'0'+second:second}`
        return result
      },
      deleteHandle(){
        const that = this
        this.$confirm({
          title: '提示',
          content: '真的删除吗，删除后不可恢复 ?',
          onOk() {
            deleteAction('/project/projectFile/delete',{id:that.data.id}).then(res=>{
              if(res.success){
                that.$emit('removeAction')
              }
            })
          },
          onCancel() {
          },
        });
      }
    },
  };
</script>

<style scoped lang='less'>
  .audio-player{
    .icon-btn{
      font-size: 20px;
    }
    .title{
      text-align: center;
      font-weight: bold;
    }
  }

</style>